import {
  SmellGasSection,
  GasLeakRecognitionSection,
  PreventiveGuidelinesSection,
  AnnualInspectionSection,
  SafeAppliancesSection,
  PostEmergencySection,
  CommercialSafetySection,
  DeveloperResponsibilitiesSection,
  ComplianceSection,
  DownloadableResourcesSection,
} from "@features/residential/components";

interface SafetyGuidelinesPageProps {
  hero: React.ReactNode;
  footer?: React.ReactNode;
}

export default function SafetyGuidelinesPage({ hero, footer }: SafetyGuidelinesPageProps) {
  return (
    <div className="w-full flex flex-col bg-white">
      {hero}
      <SmellGasSection />
      <GasLeakRecognitionSection />
      <PreventiveGuidelinesSection />
      <AnnualInspectionSection />
      <SafeAppliancesSection />
      <PostEmergencySection />
      <CommercialSafetySection />
      <DeveloperResponsibilitiesSection />
      <ComplianceSection />
      <DownloadableResourcesSection />
      {footer}
    </div>
  );
}
